<script>
import {
  iFeaturedIcon,
  iFeaturedIconSizes,
  iSpinner,
  iIcon,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
import {
  getAgentIconProperties,
  formatAgentRiskLevel,
  formatAgentConfidence,
} from './utils';

export default {
  components: { iFeaturedIcon, iSpinner, iIcon },
  props: {
    riskLevel: {
      type: String,
      required: true,
    },
    confidence: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return { iFeaturedIconSizes, hovering: false, palette };
  },
  computed: {
    isFailed() {
      return this.status === 'FAILED';
    },
    isRunning() {
      return this.status === 'RUNNING';
    },
    isFinished() {
      return this.status === 'FINISHED';
    },
    featuredIconProperties() {
      return getAgentIconProperties(this.riskLevel, this.status);
    },
    formattedRiskLevel() {
      return formatAgentRiskLevel(this.riskLevel);
    },
    formattedConfidence() {
      return formatAgentConfidence(this.confidence, this.riskLevel);
    },
    primaryText() {
      if (this.isRunning || this.isFailed) {
        return 'Customer Review Agent';
      } else if (this.isFinished) {
        return this.formattedRiskLevel;
      } else {
        return 'Customer Review Agent';
      }
    },
    secondaryText() {
      if (this.isRunning) {
        return 'Generating report...';
      } else if (this.isFailed) {
        return 'Report failed';
      } else if (this.isFinished) {
        return this.formattedConfidence;
      } else {
        return 'Status unknown';
      }
    },
  },
};
</script>

<template>
  <div
    class="report-risk-header d-flex layout-row align-items-center i-radius-xl i-px-8 i-py-8"
    :class="{ 'failed-border': isFailed }"
  >
    <div class="content d-flex layout-row align-items-center i-gap-6 w-100">
      <i-featured-icon v-bind="featuredIconProperties"></i-featured-icon>
      <div class="text d-flex flex-column align-items-start">
        <div class="i-text-button-3 i-text-neutral-120">
          {{ primaryText }}
        </div>
        <div class="i-text-body-3 i-text-neutral-110">
          {{ secondaryText }}
        </div>
      </div>
      <i-icon
        v-if="isFailed"
        symbol="medium-alert-circle"
        :size="16"
        :colour="palette['light-error-90']"
      ></i-icon>
      <i-spinner v-else-if="isRunning" size="md"></i-spinner>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.report-risk-header {
  width: 100%;
  height: 68px;
  border: 1px solid $light-neutral-60;
  background: $light-neutral-default;
  box-sizing: border-box;

  .content {
    .text {
      flex: 1;
    }
  }
}
.report-risk-header.failed-border {
  border: 1px solid $light-error-60;

  &:hover {
    border: 1px solid $light-error-60;
  }
}
</style>
